// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentNetStandardCaseRoleTypeRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentNetStandardCaseRoleTypeRelationshipModel.attributeTypeMap;
    }
}
EnrollmentNetStandardCaseRoleTypeRelationshipModel.discriminator = undefined;
EnrollmentNetStandardCaseRoleTypeRelationshipModel.additionalProperties = false;
EnrollmentNetStandardCaseRoleTypeRelationshipModel.attributeTypeMap = [
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "RoleType"
    },
    {
        "name": "caseRelations",
        "baseName": "caseRelations",
        "type": ""
    },
];
//# sourceMappingURL=enrollmentNetStandardCaseRoleTypeRelationshipModel.js.map